// import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';
import * as XLSX from 'xlsx';
// import html2canvas from 'html2canvas';

import {getFileObjByPath, getTxtContentByPath} from "../../../utils/getFileObj"

// 设置 PDF.js 的工作线程文件位置
// pdfjsLib.GlobalWorkerOptions.workerSrc = 'pdf.worker.js';

const getCommonFileThumbnailFromFile = async (file) => {
    let thumbnailUrl = "";
    if (!file.thumbnailUrl) {
        if (file.type.startsWith('image')) {
            thumbnailUrl = URL.createObjectURL(file);
        } else if (file.type === 'pdf') {
            thumbnailUrl = await generatePdfThumbnail(file);
        } else if (
            file.type.includes('spreadsheetml') ||
            file.type === 'xls' ||
            file.type === 'text/csv' ||
            file.type === 'application/vnd.ms-excel' ||
            file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ) {
            thumbnailUrl = await generateExcelThumbnail(file);
        } else {
            console.log("unknown file.type", file.type)
            thumbnailUrl = null;
        }
    }
    return thumbnailUrl;
};

const generatePdfThumbnail = async (file) => {
    console.log("generatePdfThumbnail", file);
    const pdf = await pdfjsLib.getDocument(URL.createObjectURL(file)).promise;
    const totalPages = pdf.numPages;
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    let cumulativeHeight = 0;
    let maxWidth = 0;

    // 计算总高度和最大宽度
    for (let i = 1; i <= totalPages; i++) {
        const page = await pdf.getPage(i);
        const viewport = page.getViewport({scale: 1});
        maxWidth = Math.max(maxWidth, viewport.width);
        cumulativeHeight += viewport.height;
    }

    canvas.height = cumulativeHeight;
    canvas.width = maxWidth;

    cumulativeHeight = 0; // 重置累积高度

    // 渲染每一页
    for (let i = 1; i <= totalPages; i++) {
        const page = await pdf.getPage(i);
        const viewport = page.getViewport({scale: 1});

        context.save(); // 保存当前状态
        context.translate(0, cumulativeHeight); // 移动到当前页位置

        await page.render({canvasContext: context, viewport: viewport}).promise;

        context.restore(); // 恢复状态
        cumulativeHeight += viewport.height; // 更新累积高度
    }

    return canvas.toDataURL();
};

const generateExcelThumbnail = async (file) => {
    // const reader = new FileReader();
    // reader.readAsArrayBuffer(file);
    // return new Promise((resolve, reject) => {
    //     reader.onload = (e) => {
    //         const data = new Uint8Array(e.target.result);
    //         const workbook = XLSX.read(data, {type: 'array'});
    //         const sheetName = workbook.SheetNames[0];
    //         const worksheet = workbook.Sheets[sheetName];
    //         const html = XLSX.utils.sheet_to_html(worksheet);
    //
    //         const container = document.createElement('div');
    //         container.style.position = 'absolute';
    //         container.style.top = '-9999px';
    //         container.innerHTML = html;
    //         document.body.appendChild(container);
    //
    //         html2canvas(container).then(canvas => {
    //             document.body.removeChild(container);
    //             resolve(canvas.toDataURL());
    //         }).catch(err => {
    //             document.body.removeChild(container);
    //             reject(err);
    //         });
    //     };
    //     reader.onerror = (err) => {
    //         reject(err);
    //     };
    // });
};

const generateTextThumbnail = async (textContent, isPreview = false) => {
    return new Promise((resolve) => {
        // 配置样式参数
        const fontSize = 14;
        const lineHeight = fontSize + 4; // 行高稍大，模拟自然间距
        const padding = 10;
        const borderWidth = 1;
        const font = `${fontSize}px monospace '"PingFang SC", "Microsoft YaHei", "WenQuanYi Micro Hei", sans-serif'`;

        // 分割文本为行
        const lines = textContent.split('\n');

        // 计算最大行宽（基于最长行的字符数）
        const ctx = document.createElement('canvas').getContext('2d');
        ctx.font = font;
        const maxLineWidth = Math.max(...lines.map(line => ctx.measureText(line).width));

        // 设置 canvas 尺寸
        const canvasWidth = maxLineWidth + 2 * padding + 2 * borderWidth;
        const canvasHeight = lines.length * lineHeight + 2 * padding + 2 * borderWidth;

        // 创建 canvas
        const canvas = document.createElement('canvas');
        canvas.width = canvasWidth;
        canvas.height = canvasHeight;
        const ctxFinal = canvas.getContext('2d');

        // 绘制背景
        ctxFinal.fillStyle = '#fff';
        ctxFinal.fillRect(0, 0, canvasWidth, canvasHeight);

        // 绘制边框
        ctxFinal.strokeStyle = '#ddd';
        ctxFinal.lineWidth = borderWidth;
        ctxFinal.strokeRect(borderWidth / 2, borderWidth / 2, canvasWidth - borderWidth, canvasHeight - borderWidth);

        // 绘制文本
        ctxFinal.font = font;
        ctxFinal.fillStyle = '#000';
        lines.forEach((line, index) => {
            ctxFinal.fillText(line, padding + borderWidth, padding + borderWidth + index * lineHeight);
        });

        // 返回图片 URL
        resolve(canvas.toDataURL('image/png'));
    });
};


//############ 对外api #############

export const getCommonThumbnailFromPath = async (filePath) => {
    const file = await getFileObjByPath(filePath)
    return await getCommonFileThumbnailFromFile(file)
};

export const getTxtThumbnailUrlFromPath = async (filePath) => {
    const file = await getTxtContentByPath(filePath)

    return await generateTextThumbnail(file)
};

export const getPCBFFileThumbnailUrlFromPath = async (filePath) => {
    const fileExtension = filePath.split('.').pop().toLowerCase();
    let thumbnail;
    try {
        if (fileExtension === 'drl') {
            thumbnail = await window.electronAPI.generateDrillThumbnail(filePath);
        } else if (fileExtension === 'ipc') {
            thumbnail ="" //ipc文件不处理
        }else {
            thumbnail = await window.electronAPI.generateGerberThumbnail(filePath);
        }
    } catch (error) {
        console.error(`getPCBFFileThumbnailUrlFromPath 生成缩略图时出错:${error} path:${filePath}`);
    }

    return thumbnail
};